"use client";
import { Box, Button, Columns, Row, Text } from "@dxp-feed/ui";
import { SiteContainer } from "@/components/Container";
import StoreDetailMapView from "@/templates/storeDetail/StoreDetailMapView";
import { IListStores } from "@/utils/redux/storeLocator";
import Link from "@/components/Link";
import { isCoOpStore } from "@/helpers/storeLocatorHelper";

interface IStoreDetailSelectionProps {
  store: IListStores | null;
  selectedStore: IListStores;
  openDialog: () => void;
  setStoreToConfirm: (store: IListStores) => void;
}

const StoreDetailSelection: React.FC<IStoreDetailSelectionProps> = ({
  store,
  selectedStore,
  openDialog,
  setStoreToConfirm,
}) => {
  return (
    <SiteContainer className="max-w-full  2md:px-0 px-0">
      <Row className={`mx-auto max-w-[1920px] lgs:flex-row flex-col-reverse ${isCoOpStore(store?.locationName) ? "bg-brandCoOpBlue" : "bg-brandSecondary"}`}>
        <Columns className="lgs:!w-1/2 w-full py-14  7xl:!pl-[12.5%] 6xl:!pl-[13%] 2md:!p-12 !p-6">
          {store?.storeNumber == selectedStore?.storeNumber && (
            <Text
              as="span"
              className={`rounded-[4px] bg-brandWhite py-[2px] px-2 text-body font-semibold mb-4 inline-block ${isCoOpStore(store?.locationName) ? "text-brandCoOpBlue" : "text-brandSecondary"}`}
            >
              Selected Store
            </Text>
          )}
          <Text
            as="h1"
            className="font-mavenPro 2md:text-5xl text-2xl text-brandWhite font-extrabold"
          >
            {store?.locationName}
          </Text>
          <Box className="flex 4xs:flex-row flex-col gap-4 pt-4">
            <Link
              href={`/flyer?set_preferred_store_number=${store?.storeNumber}`}
              className="!w-auto"
              tabIndex={-1}
            >
              <Button
                tabIndex={0}
                variant="primary"
                aria-label={"View Flyer"}
                className={`min-h-10 w-full 4xs:w-auto py-2 pl-4 pr-6 flex gap-2 items-center !border-brandWhite !text-body ${isCoOpStore(store?.locationName) ? "!bg-brandCoOpBlue hover:[&:before]:!bg-brandWhite focus:[&:before]:!bg-brandWhite hover:text-brandCoOpBlue focus:text-brandCoOpBlue focus:!outline-brandCoOpBlue " : "!bg-brandSecondary hover:!bg-brandWhite focus:!outline-brandSecondary [&:before]:!bg-brandWhite hover:text-brandSecondary focus:text-brandSecondary"}`}
              >
                <Text
                  as="span"
                  className="icon-flyer w-[18px] h-[18px] flex items-center justify-center"
                />
                View Flyer
              </Button>
            </Link>
            {store?.storeNumber !== selectedStore?.storeNumber && (
              <Button
                variant="outline"
                className={`min-h-10 !border-brandWhite !border-[1px] !w-auto !text-body ${isCoOpStore(store?.locationName) ? "!bg-brandWhite [&:before]:!bg-brandCoOpBlue hover:[&:before]:!bg-brandCoOpBlue focus:[&:before]:!bg-brandCoOpBlue text-brandCoOpBlue hover:text-brandWhite focus:text-brandWhite focus:!outline-brandWhite " : "!bg-brandWhite hover:!bg-brandSecondary [&:before]:!bg-brandSecondary hover:[&:before]:!bg-brandSecondary focus:[&:before]:!bg-brandSecondary text-brandSecondary hover:text-brandWhite focus:text-brandWhite focus:!outline-brandWhite"}`}
                type="submit"
                onClick={() => {
                  openDialog();
                  setStoreToConfirm(store as IListStores);
                }}
                aria-label="Select this store"
              >
                Select this store
              </Button>
            )}
          </Box>
        </Columns>
        <Columns className="lgs:!w-1/2 w-full bg-gray300">
          {/* store detail map view */}
          <StoreDetailMapView store={store} />
        </Columns>
      </Row>
    </SiteContainer>
  );
};

export default StoreDetailSelection;
